import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { ConfigProvider } from "antd";

import App from "./App";
import { store } from "./store/store";

// Buyer's dashlite theme — fonts (Nunito + Roboto + Nioicon), forms, login chrome
import "./assets/scss/dashlite.scss";
import "./App.css";
import "./index.css";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <Provider store={store}>
    <ConfigProvider
      theme={{ token: { colorPrimary: "#2563eb", borderRadius: 8 } }}
    >
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ConfigProvider>
  </Provider>
);
